'use client';
import React from 'react';
import { CartItems as Shared } from '@launchstore/shared-puck';
import { usePuckContext } from '@/components/puck/PuckContextProvider';
import { useCart } from '@/lib/hooks/useCart';
import { convertToLocale } from '@lib/util/money';

const SharedRender = (Shared as any).render;

const mapItem = (i: any, currency: string) => ({
  id: i.id,
  title: i.title ?? i.product_title ?? '',
  product_title: i.product_title ?? i.title ?? '',
  product_handle: i.product?.handle ?? i.variant?.product?.handle ?? '',
  thumbnail: i.thumbnail,
  variant: {
    id: i.variant_id ?? i.variant?.id ?? '',
    title: i.variant?.title ?? i.variant_title ?? '',
    options: (i.variant?.options ?? []).map((o: any) => ({ value: o.value ?? o.option?.value ?? '' })),
  },
  quantity: i.quantity ?? 1,
  unit_price: Number(i.unit_price) || 0,
  total: Number(i.total ?? (Number(i.unit_price || 0) * (i.quantity ?? 1))),
  isPreorder: i.metadata?.is_preorder === true,
});

/**
 * Storefront CartItems — reads the live cart, formats prices, and wires
 * quantity-change / delete to the real Medusa cart endpoints via useCart.
 * Falls back to the shared MOCK only in editor preview.
 */
function CartItemsImpl(props: any) {
  const { context } = usePuckContext() as any;
  const { updateQuantity, removeItem } = useCart() as any;
  const cart = context?.cart;

  if (!cart) {
    return <SharedRender {...props} items={undefined} />;
  }

  const currency = cart.currency_code || 'usd';
  const items = (cart.items ?? []).map((i: any) => mapItem(i, currency));
  const formatPrice = (price: number) =>
    convertToLocale({ amount: Number(price) || 0, currency_code: currency });

  return (
    <SharedRender
      {...props}
      items={items}
      onQuantityChange={(itemId: string, qty: number) => updateQuantity(itemId, qty)}
      onDelete={(itemId: string) => removeItem(itemId)}
      formatPrice={formatPrice}
    />
  );
}

export const CartItems: any = {
  ...Shared,
  render: (props: any) => <CartItemsImpl {...props} />,
};
export default CartItems;
